import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

import { HistoryTerm, Suggestion } from '~app/modules/generic/models';
import { Product } from '~shared/models';
import { ITEMS_TO_SHOW } from '~app/modules/generic/constants';
import { APP_SEARCH_ROUTE } from '~shared/constants';

@Component({
  selector: 'app-mobile-suggestions-list',
  templateUrl: './mobile-suggestions-list.component.html',
  styleUrls: ['./mobile-suggestions-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileSuggestionsListComponent {
  @Input() suggestions: Suggestion[];
  @Input() historyTerms: HistoryTerm[];
  @Input() isSuggestionsListVisible: boolean;
  @Input() suggestionsProducts: Product[];
  @Input() searchQuery: string;
  @Input() isSearchBarSuggestionExperiment: boolean;
  @Output() promoClick = new EventEmitter<boolean>();
  @Output() termSelected = new EventEmitter<Suggestion>();
  @Output() historyRemoved = new EventEmitter<HistoryTerm>();

  itemsToShow = ITEMS_TO_SHOW;
  searchRoute = `/${APP_SEARCH_ROUTE}`;
}
